module.exports = __webpack_public_path__ + "img/empty.8ed7ff2a.svg";